<template>
  <div class="p-the-c01-form-note-panel-gift-card">
    <template
      v-if="
        isGiftCardAndNormalItemInCart ||
          isWebCouponAndNormalItemInCart ||
          isGiftCardAndWebCouponItemInCart ||
          isWebCouponAndGiftItemInCart
      "
    >
      <div class="p-the-c01-form-note-panel-gift-card__content">
        ギフトコードは、他の商品と一緒に申込みできません。
      </div>
    </template>
    <template
      v-if="
        isNormalItemAndGiftCardInCart || isBenepoExchangeAndSomethingsInCart
      "
    >
      <div
        class="p-the-c01-form-note-panel-gift-card__content p-the-c01-form-note-panel-gift-card__content--wide"
      >
        こちらの商品は、カートの商品と一緒に申込みすることができません。
        カートの商品をお申込みの上、再度カートに入れていただくか、カートの商品を削除してください。
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
	props: {
		isGiftCardAndNormalItemInCart: { type: Boolean, required: false, default: false },
		isNormalItemAndGiftCardInCart: { type: Boolean, required: false, default: false },
		isWebCouponAndGiftItemInCart: { type: Boolean, required: false, default: false },
		isGiftCardAndWebCouponItemInCart: { type: Boolean, required: false, default: false },
		isWebCouponAndNormalItemInCart: { type: Boolean, required: false, default: false },
		isBenepoExchangeAndSomethingsInCart: { type: Boolean, required: false, default: false }
	}
})
export default class TheC01ItemFormNotePanelGiftCard extends Vue {
  isGiftCardAndNormalItemInCart!: boolean;
  isNormalItemAndGiftCardInCart!: boolean;
  isWebCouponAndGiftItemInCart!: boolean;
  isGiftCardAndWebCouponItemInCart!: boolean;
  isWebCouponAndNormalItemInCart!: boolean;
  isBenepoExchangeAndSomethingsInCart!: boolean;
}
</script>

<style lang="scss" scoped>
.p-the-c01-form-note-panel-gift-card {
  &__content {
    @include text__body--s;
    padding: rem(16);
    display: flex;
    letter-spacing: 0;
    border: px(1) solid $error;
    color: $error;
    width: 100%;
    line-height: rem(16);
    max-width: rem(290);

    &--wide {
      max-width: rem(568);
    }
  }
}
</style>
